import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { OrdersService } from '@core/services/orders.service';

import {
  listMyOrdersAction,
  listMyOrdersActionSuccess,
  listMyOrdersActionFailure,
} from './my-orders.actions';

@Injectable()
export class MyOrdersEffects {
  constructor(
    private actions$: Actions,
    private ordersService: OrdersService,
    private toastr: ToastrService
  ) {}

  listMyOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(listMyOrdersAction),
      switchMap((action) =>
        this.ordersService.listMyOrders(action).pipe(
          map((res) =>
            listMyOrdersActionSuccess({ listMyOrders: res.listMyOrders })
          ),
          catchError(() => {
            this.toastr.error(
              'Unable to load your orders. Please try again later or contact support.',
              'My Orders'
            );
            return [listMyOrdersActionFailure()];
          })
        )
      )
    )
  );
}
